import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

export default class AccountsWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "search", title: `Search Accounts`, href: "/accounts/search" },
            { icon: "add user", title: `Account Onboarding`, href: "/accounts/onboarding" },
            { icon: "ban", title: `Account Reports`, href: "/accounts/reports" },
            { icon: "home", title: `Room Reports`, href: "/accounts/room_reports" }
        ];

        return (
            <MenuPageWrapper title={this.props.title} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
